import React from 'react';
import { mergeClassNames } from '../../../utils';
import Icon from '../Icon';
import styles from './index.module.scss';

export default function IconButton({ IconType, onClick, className = '', disabled = false }) {
  return (
    <button className={mergeClassNames(styles.iconButton, className)} onClick={onClick} disabled={disabled}>
      <Icon IconType={IconType} />
    </button>
  );
}
